import { selectKeys, type } from "./utils";

class EventListener {
  static pubsubify(object) {
    const methods = Object.getOwnPropertyNames(EventListener.prototype).filter(
      (name) => name !== "constructor"
    );
    Object.assign(object, new EventListener());
    Object.assign(object, selectKeys(EventListener.prototype, methods));
  }

  constructor() {
    this.events = {};
  }

  on(map, callback) {
    if (type(map) !== "object") {
      map = { [map]: callback };
    }

    Object.keys(map).forEach((name) => {
      if (this.events[name] == null) {
        this.events[name] = [];
      }

      this.events[name].push(map[name]);
    });
  }

  once(name, callback) {
    const single = (...args) => {
      this.off(name, single);
      callback.apply(null, args);
    };

    this.on(name, single);
  }

  off(map, callback) {
    if (type(map) !== "object") {
      map = { [map]: callback };
    }

    Object.keys(map).forEach((name) => {
      if (this.events[name] == null) return;

      const callback = map[name];
      if (callback == null) return delete this.events[name];

      this.events[name] = this.events[name].filter((cb) => cb !== callback);
      if (this.events[name].length === 0) {
        delete this.events[name];
      }
    });
  }

  emit(name, ...args) {
    if (this.events[name] == null) return;

    return Promise.all(this.events[name].map((cb) => cb.apply(null, args)));
  }

  relay(listener, onEvent, emitEvent = onEvent) {
    this.on(onEvent, listener.emit.bind(listener, emitEvent));
  }
}

export default EventListener;



// WEBPACK FOOTER //
// ./src/js/frontendlib/event_listener.js